import { siteImage, type ResponsiveImage } from './homeImages';

/** Data for the home pillar cards (C9, reusable by Services) and the doctor strip (C11). */
export interface Pillar {
  to: string;
  title: string;
  text: string;
  image: ResponsiveImage & { alt: string; focal?: string };
}

export const PILLARS: Pillar[] = [
  {
    to: '/pediatric-chiropractic/',
    title: 'Pediatric',
    text: 'Very light, age-appropriate contacts for infants, kids, and teens after falls, growth spurts, and sports bumps, and for families who want wellness care that supports sleep, digestion, and regulation.',
    image: { ...siteImage('saylor-girl-playful-adjustment', 960, 640, [480, 768, 960]), alt: 'Dr. Anna Saylor laughing with two young girls in our jungle room', focal: '50% 40%' },
  },
  {
    to: '/prenatal-chiropractic/',
    title: 'Prenatal',
    text: 'Support for pelvic balance and comfort through pregnancy, for low back or hip pain, pelvic pressure, sciatica, rib discomfort, and stress-related tension.',
    image: { ...siteImage('prenatal-toftness-studio-portrait', 960, 640, [480, 768, 960]), alt: 'Dr. Anna Saylor smiling with a pregnant patient during her visit', focal: '40% 45%' },
  },
  {
    to: '/family/',
    title: 'Family',
    text: 'Gentle, precise adjustments for parents and grandparents too, for back and neck tension, headaches, stiff joints, or the stuck feeling that follows stress, injury, or long hours sitting.',
    image: { ...siteImage('zach-pick-f6931ce2ad-wide', 1440, 960, [480, 768, 960, 1440]), alt: 'Dr. Zach Conner giving a woman lying face down a gentle adjustment along her spine', focal: '45% 40%' },
  },
];

export const DOCTORS = [
  { to: '/dr-anna-saylor/', img: '/images/dr-anna.webp', name: 'Dr. Anna Saylor', note: 'Founder • teaches KST • holds DICCP' },
  { to: '/dr-john-johr/', img: '/images/clinic-2026/dr-john-headshot-2026-w960.webp', name: 'Dr. John Johr', note: 'Gentle, nervous-system focused care for all ages' },
  { to: '/dr-zach-conner/', img: '/images/dr-zach.webp', name: 'Dr. Zach Conner', note: 'Teaches Talsky Tonal • gentle care for all ages' },
];
